import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Loading } from '../../../../../loadbar/Loading';
import { isDataManager } from '../../../../../../role/roleUtils';
import {
  clearPageData as clearPageDataAc,
  getDeposits as getDepositsAc,
  getPublications as getPublicationsAc,
  getGeologicAges as getGeologicAgesAc,
  toggleColumns as toggleColumnsAc,
  sortData as sortDataAc,
  deleteDeposit as deleteDepositAc,
  getTsunami as getTsunamiAc,
} from '../../../../../../redux/tsunamis/event/related-deposit/tsunamiRelatedDepositsActions';
import { withUser } from '../../../../../auth/withUser';
import { TsunamiSingleResultGrid } from '../related-runup/TsunamiSingleResultGrid';
import { DepositDataGrid } from '../../deposits/data/DepositDataGrid';

class TsunamiRelatedDepositPageUnwrapped extends Component {
  componentDidMount() {
    document.title = 'NCEI Hazard Tsunami Related Deposit Results';
    const {
      match: { params: { id } },
      getDeposits,
      getTsunami,
      clearPageData,
      getGeologicAges,
      getPublications,
    } = this.props;
    clearPageData();
    getDeposits({ id });
    getTsunami({ id });
    getGeologicAges();
    getPublications();
  }

  componentWillUnmount() {
    const { clearPageData } = this.props;
    clearPageData();
  }

  render() {
    const {
      match: { params: { id } },
      fetched,
      tsunami,
      deposits,
      authorities,
      sort,
      visibleColumns,
      sortData,
      toggleColumns,
      deleting,
      deleteDeposit,
      getDeposits,

    } = this.props;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    return (
      <div className="haz-results-container haz-page-container">
        <div className="haz-info-content">
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h1">Tsunami Event</CardTitle>
                <TsunamiSingleResultGrid tsunami={tsunami} dataManager={dataManager} />
              </CardBody>
            </Card>
          </div>
        </div>

        <div className="haz-info-content haz-data-grid-container">
          <div className="haz-info-content-section haz-data-grid-container">
            <Card>
              <CardBody>
                <CardTitle tag="h2">{`Deposit References - ${deposits.size} Results Found`}</CardTitle>

                <DepositDataGrid
                  deposits={deposits}
                  dataManager={dataManager}
                  sortData={sortData}
                  sort={sort}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  searchParams={`Tsunami ID = ${tsunami.get('id')}`}
                  deleting={deleting}
                  deleteDeposit={deleteDeposit}
                  onDeleteCloseModal={() => getDeposits({ id })}
                />

              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

TsunamiRelatedDepositPageUnwrapped.propTypes = {
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  deposits: ImmutablePropTypes.list.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  sortData: PropTypes.func.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  deleteDeposit: PropTypes.func.isRequired,
  getDeposits: PropTypes.func.isRequired,
  getTsunami: PropTypes.func.isRequired,
  clearPageData: PropTypes.func.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  getPublications: PropTypes.func.isRequired,
  getGeologicAges: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['tsunamiRelatedDepositsPage', 'fetchedTsunami']),
    state.getIn(['tsunamiRelatedDepositsPage', 'fetchedDeposits']),
    state.getIn(['tsunamiRelatedDepositsPage', 'fetchedGeologicAges']),
    state.getIn(['tsunamiRelatedDepositsPage', 'fetchedPublications']),
  ].every(v => v),
  deleting: state.getIn(['tsunamiRelatedDepositsPage', 'deleting']),
  tsunami: state.getIn(['tsunamiRelatedDepositsPage', 'tsunami']),
  deposits: state.getIn(['tsunamiRelatedDepositsPage', 'deposits']),
  sort: state.getIn(['tsunamiRelatedDepositsPage', 'sort']),
  visibleColumns: state.getIn(['tsunamiRelatedDepositsPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  clearPageData: clearPageDataAc,
  getDeposits: getDepositsAc,
  getPublications: getPublicationsAc,
  getGeologicAges: getGeologicAgesAc,
  toggleColumns: toggleColumnsAc,
  sortData: sortDataAc,
  deleteDeposit: deleteDepositAc,
  getTsunami: getTsunamiAc,
}, dispatch);


export const TsunamiRelatedDepositPage = withUser(connect(mapStateToProps, mapDispatchToProps)(TsunamiRelatedDepositPageUnwrapped));
